export const environment = {
  production: false,

  apiBaseUrl: 'https://api.loadcargo.dev.iagcargo.com/v1',
  appSync: {
    endpoint:
      'https://mqzz5z5hgbh5ppjp7ydqrjc5hu.appsync-api.eu-west-1.amazonaws.com/graphql',
    region: 'eu-west-1',
    authMode: 'oidc',
  },
  msalConfig: {
    auth: {
      clientId: 'ed36ca12-a255-4c5d-8fc0-bd9e1f386b92',
      authority: 'https://login.microsoftonline.com/011da57f-b251-41f7-bf22-e42fa42028a5',

      redirectUri: 'https://ui.loadcargo.dev.iagcargo.com/oauth/callback',
      postLogoutRedirectUri: 'https://ui.loadcargo.dev.iagcargo.com/',
    },
  },
  apiConfig: {
    scopes: ['User.Read.All'],
    uri: 'https://graph.microsoft.com/.default',
  },
  loadCargoApi: {
    uri: 'https://api.loadcargo.dev.iagcargo.com/v1',
    scopes: ['api://ba4b644c-2786-408d-a3d2-2fead4066ab2/access_as_user'],
  },
};
